const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Faça aqui a sua escolha.",
  seeAll: "Ver tudo",
  clear: "Eliminar",
  back: "Voltar",
  save: "Guardar",
  close: "Fechar",
  of: "De",
  to: "à",
  copyrights: "© {date} Bridgestone Solutions. Todos os direitos reservados",
  pageNotFound: "Página não encontrada",
  accessDenied: "Acesso negado",
  search: "Pesquisar",
  year: "Ano",
  buttons: {
    loading: "A carregar...",
    export: "Exportar",
    delete: "Eliminar",
    save: "Guardar",
    cancel: "Cancelar",
    next: "Continuar",
    back: "Voltar atrás",
    skip: "Saltar",
    send: "Enviar",
    clear: "Eliminar",
    readNow: "Leia agora",
    more: "Mais",
    close: "Fechar",
    reportError: "Reportar erro",
    accept: "ACEITAR",
    download: "Descarregar",
    downloadAll: "Transferir tudo",
    selectAll: "Selecionar tudo",
    deselectAll: "Desselecionar tudo",
    downloadSelection: "Transferir seleção",
    dealerInfoDownload: "Download",
    toTheBasket: "ir para a cesta",
    toOrderDelivery: "Continue para a morada de entrega",
    discover: "Descubra",
    newAddress: "Criar nova morada de entrega",
    selectAddressBtn: "Selecione a sua morada de entrega",
    toOrderSummary: "Resumo do pedido",
    placeOrder: "Confirmar pedido",
    toDashboard: "Ir para a página inicial",
    newOrder: "Novo pedido",
    userOrders: "PARA OS SEUS PEDIDOS",
    toSearch: "PESQUISAR",
    select: "Selecionar",
    moreCustomerNumbers: "+ ADICIONAR MAIS NÚMEROS DE CLIENTES",
    pointsList: "Ir para o extrato de conta",
    loadMore: "Carregar mais",
    toStaffDashboard: "Para o painel",
    toQuiz: "Para o quiz",
    vouchers: "Vales",
    exchangeVoucher: "Resgatar código de vale",
    confirm: "Confirmar",
    sharePoints: "Partilhar pontos",
    create: "Criar",
    update: "Atualizar",
    toBDrive: "Para o B-Drive",
    preview: "Pré-visualização",
    clickHere: "Ver detalhes",
    setFilters: "Defina <b>no máximo um filtro por coluna</b>",
    all: "Todos",
  },
  tooltips: {
    info: "Precisa de Ajuda?",
  },
  confirmation: {
    header: "Confirmação necessária",
    message: "Deseja eliminar este registo?",
  },
  nav: {
    consents: "Consentimentos",
    dashboard: "Início",
    accountDashboard: "Painel",
    account: "O meu perfil",
    mailbox: "Caixa de entrada",
    singleMailbox: "Mensagem",
    stammdaten: "O meu perfil",
    news_feeds: "Notícias",
    pointsOverview: "Os meus pontos",
    rewardsOverview: "Os meus pontos",
    about: "Sobre a Bridgestone",
    service_number: "Contactos e Serviços",
    shop: "Loja de recompensas",
    salesPromotions: "Promoções de vendas",
    promotions: "A minha conta",
    shopCategory: "Loja de recompensas",
    productDetails: "Detalhes do produto",
    userOrders: "Encomendas",
    shoppingCart: "Carrinho de compras",
    orderDelivery: "Morada de entrega para envio",
    orderSummary: "Resumo do pedido",
    orderComplete: "Pedido concluído",
    text_page: "Página estática",
    staff: "Painel de serviço",
    onlineTrainings: "Formações online",
    trainings: "Formações",
    training: "Formação",
    trainingForm: "Formulário de formação",
    staffVouchers: "Vales",
    wholesalerVouchers: "Vales",
    brochure_prices: "Listas de preços e brochuras",
    investment: "Apoio ao investimento",
    media: "Media",
    medias: "Media",
    contact_service: "CONTACTOS E SERVIÇOS",
    productInfo: "INFORMAÇÃO DO PRODUTO",
    bDrive: "Imagens de produtos",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Condições de participação",
    first_stop: "Garantia de pneus Bridgestone",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Início",
    accountDashboard: "Painel",
    account: "O meu perfil",
    mailbox: "Caixa de entrada",
    singleMailbox: "Mensagem",
    stammdaten: "O meu perfil",
    news_feeds: "Notícias",
    pointsOverview: "Os meus pontos",
    rewardsOverview: "Os meus pontos",
    about: "Sobre a Bridgestone",
    service_number: "Contactos e Serviços",
    shop: "Loja de recompensas",
    salesPromotions: "Promoções de vendas",
    promotions: "A minha conta",
    shopCategory: "Loja de recompensas",
    productDetails: "Detalhes do produto",
    userOrders: "Encomendas",
    shoppingCart: "Carrinho de compras",
    orderDelivery: "Morada de entrega para envio",
    orderSummary: "Resumo do pedido",
    orderComplete: "Pedido concluído",
    staff: "Painel de serviço",
    onlineTrainings: "Formações online",
    trainings: "Formações",
    training: "Formação",
    trainingForm: "Formulário de formação",
    staffVouchers: "Vales",
    wholesalerVouchers: "Vales",
    brochure_prices: "Listas de preços e brochuras",
    investment: "Apoio ao investimento",
    media: "Media",
    medias: "Media",
    contact_service: "CONTACTOS E SERVIÇOS",
    productInfo: "INFORMAÇÃO DO PRODUTO",
    bDrive: "Imagens de produtos",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Condições de participação",
    first_stop: "Garantia de pneus Bridgestone",
    payouts: "Payouts",
},
  menu: {
    account: "O meu perfil",
    plus: 'Sobre a Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Suporte de vendas",
    mailbox: "Caixa de entrada",
    about: "Sobre a Bridgestone",
    trainingAndCourses: "Formações e cursos",
    externalTraining: "Formações externas",
    productInfo: "Informações sobre os produtos",
    productBrochures: "Brochuras de produtos",
    priceLists: "Listas de preços",
    price: "Pricat",
    complaintForm: "Formulário de reclamação",
    sales_support: "Suporte de vendas",
    contact_service: "CONTACTOS E SERVIÇOS",
    logOut: "Desconectar",
    news: "Notícias",
    news_feeds: "Notícias",
    service_number: "Contactos e Serviços",
    stammdaten: "O meu perfil",
    salesPromotions: "Promoções de vendas",
    shop: "Loja de prémios",
    onlineTrainings: "Formações online",
    trainings: "Formações",
    brochure_prices: "Listas de preços e brochuras",
    media: "Media",
    medias: "Media",
    preislisten: "Listas de preços",
  },
  validation: {
    requiredField: "Campo obrigatório",
  },
  sortBy: {
    default: "Ordenar por",
    desc: "Ordenar por: Mais recentes",
    asc: "Ordenar por: Mais antigos",
    name: "Nome",
    date: "Data",
    choiceBy: "Ordenar",
  },
  month: {
    1: "janeiro",
    2: "fevereiro",
    3: "março",
    4: "abril",
    5: "maio",
    6: "junho",
    7: "julho",
    8: "agosto",
    9: "setembro",
    10: "outubro",
    11: "novembro",
    12: "dezembro"
  },
};


export default {
  messages,
};
